<!--
    校区管理-上课统计
    功能：展示校区课程上课列表详情
    说明：添加版本3.0需求
-->
<template>
  <div
    v-loading="loading"
    class="statistical">
    <!--    <div class="total">-->
    <!--      <p>累计上课次数<b>300</b></p>-->
    <!--      <p>累计直播消费金额<b>1000</b></p>-->
    <!--      <p>累计录课消费金额<b>1000</b></p>-->
    <!--      <p>累计回放消费金额<b>1000</b></p>-->
    <!--      <p>当月上课次数<b>30</b></p>-->
    <!--      <p>当月直播消费金额<b>100</b></p>-->
    <!--      <p>当月录课消费金额<b>1000</b></p>-->
    <!--      <p>当月回放消费金额<b>1000</b></p>-->
    <!--    </div>-->
    <el-tabs
      v-model="activeName"
      @tab-click="handleClick">
      <el-tab-pane
        label="上课统计"
        name="school_teaching">
        <!--
          excelLabel="导出excel"-->
        <AppList
          v-if="activeName === 'school_teaching'"
          ref="list_live"
          :list.sync="list_live"
          :columns="columnsLiveAll"
          :columns-check="columnsLive"
          :api-type="apiUrl"
          :excel-label="'导出搜索数据'"
          :excel-loading="excelLoading"
          title=""
          api="/api/liveroom/all/bill"
          @checkedColumns="checkedColumns"
          @excelPage="excelExport"
        >
          <!--           /api/liveroom/all/bill?is_show_teacher=1-->
          <AppSearch
            slot="search"
            :order="{ type: 'id', name: 'desc'}"
            :search-arr="searchArrLive"
            date-type="search"/>
          <template slot-scope="props">
            <el-table :data="props.listData">
              <el-table-column
                v-for="column in columnsLive"
                v-if="!column.show"
                :key="column.prop"
                :prop="column.prop"
                :label="column.label"
                :width="column.width"
                :formatter="column.formatter"
              />
              <el-table-column
                v-if="factor !== 'factor'"
                label="操作"
                width="80px"
                class="orgin-btn"
              >
                <template slot-scope="scope">
                  <template v-if="$permissions('school_statistics_consume_info')">
                    <el-link
                      v-if="$store.state.from === 'schoolCenter'"
                      @click="StatisticalClass(scope.row)"
                    >详情</el-link>
                    <el-button
                      v-else
                      size="small"
                      @click="StatisticalClass(scope.row)"
                    >详情</el-button>
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </AppList>
      </el-tab-pane>
      <el-tab-pane
        label="录制统计"
        name="school_record">
        <AppList
          v-if="activeName === 'school_record'"
          ref="list"
          :list.sync="list_record"
          :api="api_record"
          :api-type="api_record"
          title="">
          <AppSearch
            slot="search"
            :order="{ type: 'id', name: 'desc'}"
            :search-arr="searchArrRecord"/>
          <template slot-scope="props">
            <el-table :data="props.listData">
              <el-table-column
                v-for="column in columnsRecord"
                v-if="!column.show"
                :key="column.prop"
                :prop="column.prop"
                :label="column.label"
                :width="column.width"
                :formatter="column.formatter"
              />
              <el-table-column
                label="操作"
                width="200px"
                class="orgin-btn">
                <template slot-scope="scope">
                  <template v-if="factor !== 'factor'">
                    <el-link
                      v-if="$store.state.from === 'schoolCenter'"
                      @click="StatisticalClass(scope.row, 'record')"
                    >详情</el-link>
                    <el-button
                      v-else
                      size="small"
                      @click="StatisticalClass(scope.row, 'record')"
                    >详情</el-button>
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </AppList>
      </el-tab-pane>
      <el-tab-pane
        label="回放统计"
        name="school_replay">
        <AppList
          v-if="activeName === 'school_replay'"
          ref="list"
          :list.sync="list_replay"
          :api="api_replay"
          :api-type="api_replay"
          title="">
          <AppSearch
            slot="search"
            :order="{ type: 'id', name: 'desc'}"
            :search-arr="searchArrReplay"/>
          <template slot-scope="props">
            <el-table :data="props.listData">
              <el-table-column
                v-for="column in columnsReplay"
                v-if="!column.show"
                :key="column.prop"
                :prop="column.prop"
                :label="column.label"
                :width="column.width"
                :formatter="column.formatter"
              />
              <el-table-column
                label="操作"
                width="80px"
                class="orgin-btn">
                <template slot-scope="scope">
                  <template v-if="factor !== 'factor'">
                    <el-link
                      v-if="$store.state.from === 'schoolCenter'"
                      @click="StatisticalClass(scope.row, 'replay')"
                    >详情</el-link>
                    <el-button
                      v-else
                      size="small"
                      @click="StatisticalClass(scope.row, 'replay')"
                    >详情</el-button>
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </AppList>
      </el-tab-pane>
      <el-tab-pane
        label="购买课程消费统计"
        name="school_course">
        <AppList
          v-if="activeName === 'school_course'"
          ref="list"
          :list.sync="list_course"
          :api="api_course"
          :transfer="transfer"
          title=""
        >
          <AppSearch
            slot="search"
            :order="{ type: 'updated_at', name: 'desc'}"
            :search-call="searchCall"
            :search-arr="searchArrCourse"/>
          <template slot-scope="props">
            <el-table :data="props.listData">
              <el-table-column
                v-for="column in columnsCourse"
                v-if="!column.show"
                :key="column.prop"
                :prop="column.prop"
                :label="column.label"
                :width="column.width"
                :formatter="column.formatter"
              />
              <el-table-column
                label="操作"
                width="80px"
                class="orgin-btn">
                <template slot-scope="scope">
                  <template v-if="factor !== 'factor' && scope.row.commodities">
                    <el-link
                      v-if="$store.state.from === 'schoolCenter'"
                      @click="courseDetail(scope.row.id)"
                    >详情</el-link>
                    <el-button
                      v-else
                      size="small"
                      @click="courseDetail(scope.row.id)"
                    >详情</el-button>
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </AppList>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      :visible.sync="dialogDetail.show"
      title="订单详情"
      class="dialog-sp1"
      width="647px">
      <div class="dialog-detail">
        <div class="detail-row">
          <div class="detail-col flex jb">
            <div><span class="gray">商品名称：</span>{{ dialogDetail.data.commodities.name }}</div>
            <div><span class="gray">商品编号：</span>{{ dialogDetail.data.commodities.code }}</div>
            <div><span class="gray">订单号：</span>{{ dialogDetail.data.code }}</div>
          </div>
          <div class="detail-col flex jb">
            <div><span class="gray">创建时间：</span>{{ dialogDetail.data.created_at }}</div>
            <div><span class="gray">创建账户：</span>{{ dialogDetail.data.user.mobile }}</div>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-col flex jb">
            <div><span class="gray">线下课时单价（课时/次）：</span>原价：{{ dialogDetail.data.commodities.offline_price }}金币</div>
            <div><span class="gray">优惠价：</span>{{ dialogDetail.data.commodities.offline_discount_price }}金币</div>
          </div>
          <div class="detail-col flex jb">
            <div><span class="gray">线上课时单价（课时/学生/次）：</span>原价：{{ dialogDetail.data.commodities.online_price }}金币</div>
            <div><span class="gray">优惠价：</span>{{ dialogDetail.data.commodities.online_discount_price }}金币</div>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-col flex jb">
            <div><span class="gray">线下课次（课时/次）：</span>{{ dialogDetail.data.offline_num }}次</div>
          </div>
          <div class="detail-col flex jb">
            <div><span class="gray">线上学生课次（课时/学生/次）：</span>{{ dialogDetail.data.online_num }}次</div>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-col flex jb">
            <div><span class="gray">支付状态：</span>{{ dialogDetail.data.status_text }}</div>
            <div v-if="dialogDetail.data.paid_at"><span class="gray">支付时间：</span>{{ dialogDetail.data.paid_at }}</div>
          </div>
          <div class="detail-col flex jb">
            <div/>
            <div><span class="gray">套餐金币抵扣：</span>{{ dialogDetail.data.coin_paid }}金币</div>
          </div>
          <div class="detail-col flex jb">
            <div/>
            <div><span class="gray">原总价：</span>{{ dialogDetail.data.original_coin }}金币</div>
          </div>
          <div class="detail-col flex jb">
            <div/>
            <div><span class="gray">现金支付：</span>{{ dialogDetail.data.cash_paid }}元</div>
          </div>
          <div class="detail-col flex jb">
            <div/>
            <div><span class="gray">优惠总价：</span><span class="red">{{ dialogDetail.data.discount_coin }}金币</span></div>
          </div>
        </div>
      </div>
      <div class="detail-foot flex jc">
        <el-button
          type="primary"
          @click="dialogDetail.show = false">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import index from './';

export default index;
</script>

<style scoped lang="scss">
  @import '../../assets/reset.scss';
  @import "index.scss";
</style>



// WEBPACK FOOTER //
// src/views/Statistical/index.vue